export const actions = {
    axn_initSettings( { commit }, value ) {
        commit('set_initSettings', value);
    },
};
